module.exports = __webpack_public_path__ + "static/bg2-8e99117d2cc31961ecf2bd2765448d46.png";